//add video to library
import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../../util/constants";
import * as types from "../../types";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function purchaseContent(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/viewer/clipstore/purchase?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.PURCHASE_CONTENT_REQUEST, types.PURCHASE_CONTENT_RECEIVE, {
                type: types.PURCHASE_CONTENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetPurchaseContent = () => ({
    type: types.RESET_PURCHASE_CONTENT,
    payload: null
});